module.exports = __webpack_public_path__ + "static/media/A1-27-Groxxyn-Ev-cod125.2037ec2f.png";